module.exports = __webpack_public_path__ + "static/media/support_agent_black.03348eb2.svg";